import axios from "../../../common/config/axios";
import * as actionType from './types';

export const getList = (props) => dispatch =>
{
    axios.get('delay_bonus/list', {params: props})
    .then(function (response)
    {
        dispatch (
            {
                type: actionType.LIST,
                value: response.data
            }
        )
    })
    .catch(err =>
        {
            
        })
}

export const getDropDown = () => dispatch =>
{
    axios.get('delay_bonus/drop_down')
    .then(function (response) 
    {
      dispatch (
      {
        type: actionType.DROPDOWN,
        value: response.data
      })
    })
    .catch(err => 
    {
      
    });
}

export const getDetails = (props) => dispatch =>
{   
    axios.get('delay_bonus/details',{params: props})
    .then(function (response) 
    {
      dispatch (
      {
        type: actionType.DETAILS,
        value: response.data
      })
    })
    .catch(function (error) 
    {
      
    });
};

export const updateTran = (data) => (dispatch, getState) =>
{
    data.country_id = getState().currentUser.data.country_id;
    // console.log(data);
    axios.post('delay_bonus/update', data)
    .then(function (response) 
    {
      dispatch (
      {
        type: actionType.UPDATE,
        value: response.data
      })
    })
    .catch(err => 
    {
      
    });
};

export const updateTranStatus = (data) => (dispatch, getState) =>
{
    data.country_id = getState().currentUser.data.country_id;
    // console.log(data);
    axios.post('delay_bonus/update', data)
    .then(function (response) 
    {
      dispatch (
      {
        type: actionType.UPDATE_STATUS,
        value: response.data
      })
    })
    .catch(err => 
    {
      
    });
};
